import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Link,
  useHistory,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import backArrowIcon from "../../assets/img/back-arrow.png";
import { API_URL } from "../../utils/constant";
import RoleDropdown from "../../components/RoleDropDown";
import { useAuth } from "../../routers/AuthProvider";
import { Toast } from '../../components/ToastComponent';

export default function EditOfficeUser() {
  const params = useParams();
  const location = useLocation();
  const { initialData } = location.state;
  const { loading, setLoading } = useAuth();
  const backPath = `/office-user/office-user-list`;
  const { handleInputChange, formData, setFormData, submitForm, error } = useForm();
      useEffect(()=>{
          if(error){
             Toast.fire({
      title: error ,
      icon: "error",
    });
          }
      },[error])
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    const data = {
      ...formData,
      status: "ACTIVE",
    };
    submitForm("PUT", "/user/" + params.id, data, () => {
      navigate(backPath);
    }, "Successfully Updated");
  };

  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);
  useEffect(() => {
    axios
      .get(API_URL + "/role?sort=role_level", {
        withCredentials: true,
      })
      .then((response) => {
        setRoles(response.data.data);
      })
      .catch(() => {
        setRoles([]);
      })
      .finally(() => {
        setRolesLoading(false);
      });
  }, []);

          const [errorPhone1Message, setErrorPhone1Message] = useState("");
          const [errorPhone2Message, setErrorPhone2Message] = useState("");
          const [errorPhone3Message, setErrorPhone3Message] = useState("");
          const [errorPhone4Message, setErrorPhone4Message] = useState("");
      
          const handleChange = (e) => {
              const { name, value } = e.target;
      
              if (/[^0-9]/.test(e.target.value)) {
                  //setErrorPhoneMessage("Only numbers are allowed.");
                  if (name === 'phone1') {
                      setErrorPhone1Message("Only numbers are allowed.");
                  } else if (name === 'phone2') {
                      setErrorPhone2Message("Only numbers are allowed.");
                  }
                  else if (name === 'phone3') {
                      setErrorPhone3Message("Only numbers are allowed.");
                  }
                  else {
                      setErrorPhone4Message("Only numbers are allowed.");
                  }
              } else {
                  setErrorPhone1Message("");
                  setErrorPhone2Message("");
                  setErrorPhone3Message("");
                  setErrorPhone4Message("");  // Clear message when input is valid
              }
      
              // Allow digits only for phone inputs
              const numericValue = value.replace(/[^0-9]/g, "");
              setFormData((prev) => ({
                  ...prev,
                  [name]: numericValue,
              }));
      
          };
      
          const [errorMessage, setErrorMessage] = useState("");

  return (
    <div className="sub-page-layout-1">
      <Link className="back-to-page" to={backPath}>
        <img src={backArrowIcon} />
        Back
      </Link>
      <div className="container">
        <h1 className="sub-page-title">Edit Office User</h1>
        <div className="form-container">
          <form
            onSubmit={onSubmit}
            className="form flex flex-col justify-between w-full"
          >
            <div className="grid grid-cols-2 gap-9">
              <div className="grow">
                <label className="x-label input-required">User Role</label>
                <div className="dd-container">
                  <select
                    type="text"
                    required
                    name="role_id"
                    disabled={rolesLoading}
                    onChange={handleInputChange}
                    // defaultValue={initialData.role.role_id}
                    value={
                      formData?.role_id ?? initialData?.role?.role_id ?? ""
                    }
                    // value={formData.district_id ? formData.district_id : ''}
                    className="x-input dropdown"
                  >
                    {rolesLoading && (
                      <option value="" disabled>
                        Loading roles...
                      </option>
                    )}
                    {!rolesLoading &&
                      roles.map((item, index) => (
                        <option key={index} value={item.role_id}>
                          {item.role_name}
                        </option>
                      ))}
                  </select>
                </div>
                {/* {console.log(initialData.role)} */}
                {/* <RoleDropdown
                                    value={formData.role_id ? formData.role_id : ''}
                                    onChange={handleInputChange}
                                    required
                                    name='role_id'
                                /> */}
              </div>
              <div className="grow">
                <label className="x-label input-required">Name</label>
                <input
                  type="text"
                  required
                  name="name"
                  defaultValue={initialData.name}
                  // value={formData.name ? formData.name : ''}
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>
              <div className="grow">
                <label className="x-label input-required">Username</label>
                <input
                  type="text"
                  required
                  defaultValue={initialData.username}
                  // disabled//????
                  // value={formData.username ? formData.username : ''}
                  name="username"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>
              <div className="grow">
                <label className="x-label input-required">Phone Number</label>
                <input
                  type="text"
                  required
                  defaultValue={initialData.phone1}
                  // value={formData.phone ? formData.phone : ''}
                  name="phone1"
                  inputMode="numeric"
                  pattern="^09[0-9]{7,9}$"
                  onChange={handleChange}
                  className="x-input"
                />
                {errorPhone1Message && (
                      <div className="text-red-500 text-sm mt-1">{errorPhone1Message}</div>
                  )}
              </div>
              <div className="grow">
                <label className="x-label">Description</label>
                <input
                  type="text"
                  // value={formData.description ? formData.description : ''}
                  defaultValue={initialData.remark}
                  name="remark"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>
            </div>
            <div className="form-btn-group">
              {/* {error ? (
                <span className="w-full block mb-5 text-lg text-red-500 text-right">
                  {error}
                </span>
              ) : (
                ""
              )} */}
              <div className="flex justify-end gap-5">
                <Link
                  to={backPath}
                  className="white-btn"
                  style={loading ? { pointerEvents: "none", opacity: 0.6 } : undefined}
                >
                  Cancel
                </Link>
                <button type="submit" className="gold-btn" disabled={loading}>
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
